import { Container } from "@mui/material";
import TablaUsuariosV2 from "@/components/Tablas/TablaUsuariosV2";
import useTablaUsuarios from "@/components/Tablas/TablaUsuariosV2/useTablaUsuarios";
import { useContext, useEffect } from "react";
import { EmpresaContext } from "../VerEmpresasPage";

const UsuariosSection = () => {
    const { empresa } = useContext(EmpresaContext)
    const useTable = useTablaUsuarios()

    useEffect(() => {
        const usuariosConCompany = empresa?.usuarios.map(user => ({ ...user, company: empresa }))
        useTable.setUsuarios(usuariosConCompany || [])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [empresa])

    return (
        <Container>
            <TablaUsuariosV2 hook={useTable}
                hideSearchCompany
                hideColumnEmpresa
            />
        </Container>
    );
}

export default UsuariosSection;